// NOTE this is already obsolete, this should be removed as soon as the profile
// edit screen is replaced with the new profile editor hotness

function limitBlurbLength() {
  const MAX_LENGTH = 250;
  const $blurbInput = $('#profile_blurb');

  if (!$blurbInput.length) return;

  const $counter = $('<span class="blurb-counter"></span>');

  $counter.insertAfter($blurbInput);

  function updateCounter() {
    const { length } = $blurbInput.val();
    const opacity = (length / MAX_LENGTH * 0.8) + 0.2;

    $counter
      .text(`${length}/${MAX_LENGTH}`)
      .css('opacity', opacity);
  }

  $blurbInput.on('input', () => {
    $blurbInput.val($blurbInput.val().substring(0, MAX_LENGTH));
    updateCounter();
  });

  updateCounter();
}

export default function bootstrap() {
  limitBlurbLength();
}
